import {
  TaxMonthlyContent,
  TaxYearlyPlanContent,
} from "components/billing/TaxSubscriptionUpdate/TaxSubscriptionUpdate";
import { ThinArrowRight } from "components/icons/ThinArrowRight";
import React from "react";

export const CartPlanConvertUI = () => (
  <div className="t-flex t-gap-3 t-items-center t-mt-2.5">
    <div className="t-flex-1 t-basis-0 t-min-w-0 t-rounded-lg t-border t-border-solid t-border-neutral-10">
      <div className="t-bg-surface-lighter-grey t-py-4 t-px-5 t-rounded-lg t-h-full">
        <TaxMonthlyContent />
      </div>
    </div>
    <ThinArrowRight className="t-text-purple-30 t-shrink-0" />
    <div
      className="t-flex-1 t-basis-0 t-min-w-0 t-rounded-lg t-p-[1px]"
      style={{
        background: "linear-gradient(90deg, #C2B0FF 0%, #FFE5E8 100%)",
      }}
    >
      <div className="t-py-[18px] t-px-5 t-bg-surface-purple t-rounded-lg t-h-full">
        <TaxYearlyPlanContent isFromCart />
      </div>
    </div>
  </div>
);
